/**
 * Treats an empty display string as absent while preserving whitespace.
 * @param value - Optional text returned by a form or API.
 * @returns The original nonempty string, or undefined for empty/missing text.
 */
export const nonEmptyString = <T extends string>(
  value: T | null | undefined
): T | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;
